import React from 'react'
import type { ComponentProps, MacroComponentData } from '@enonic/react-components'
import KeyDataPrototype from '/react4xp/components/prototype/KeyData'
import type { KeyDataColour, KeyDataItem } from '/react4xp/components/prototype/KeyData/types'

type KeyDataMacroItem = {
	value?: string
	label?: string
	text?: string
	colour?: string
}

type KeyDataMacroData = {
	items?: KeyDataMacroItem[]
}

export const KeyDataMacro = ({ data }: ComponentProps<MacroComponentData>) => {
	const { items } = (data || {}) as KeyDataMacroData

	if (!items || items.length === 0) {
		return null
	}

	// `colour` is a ComboBox value constrained to the prototype's colour keys by the macro
	// schema, but it reaches the view as a plain string, so cast rather than re-validate —
	// the prototype falls back to `purple` on anything it does not recognise. A draft saved
	// without the required Colour still renders, on the same `beige` default the schema sets.
	const cards: KeyDataItem[] = items.map((item) => ({
		value: item.value,
		label: item.label,
		text: item.text,
		colour: (item.colour || 'beige') as KeyDataColour,
	}))

	// Inside a RichText field the surrounding block already provides the
	// container, so no `isPart` here.
	return <KeyDataPrototype items={cards} />
}
